import script from "./FormFormRight.vue?vue&type=script&setup=true&lang=js"
export * from "./FormFormRight.vue?vue&type=script&setup=true&lang=js"

import "./FormFormRight.vue?vue&type=style&index=0&id=61b0f83a&lang=scss"

const __exports__ = script;

export default __exports__